import React, { PropsWithChildren } from 'react';
import Wrapper from './styles';

export default function HorseRacingUiTag({ children }: PropsWithChildren) {
    return <Wrapper>{children}</Wrapper>;
}
